import { FC } from 'react'
import SocialLinks from 'components/SocialLinks'
import { Constants } from 'common/utils'
import Heading from 'components/Heading'
import Strings from 'project/localisation' // we need this to make JSX compile
import cn from 'classnames'

type CompanyInformationType = {
  au?: boolean
  className?: string
}

const CompanyInformationCard: FC<CompanyInformationType> = ({
  au,
  className,
}) => {
  const data = Constants.companyInformation
  const phone = au ? data.phoneAu : data.phone
  const email = au
    ? Constants.companyInformation.emailAu
    : Constants.companyInformation.email
  return (
    <div className={className}>
      <span className='text-small d-block mt-sm-0 mt-2'>
        {au
          ? Strings.openingHoursDescriptionAu
          : Strings.openingHoursDescription}
      </span>
      <div className='d-flex flex-column'>
        <a className='text-link color-blue text-small' href={`tel:${phone}`}>
          {phone}
        </a>
        <a
          href={`mailto:${email}`}
          className='text-link color-blue mt-0 pt-0 text-small d-block text-decoration-none'
        >
          {email}
        </a>
      </div>
    </div>
  )
}

export default CompanyInformationCard
